import { brandAssetCandidates, brandPartsFromDomain, getBrandSlug as slugFromName, resolveBrand } from "../../server/brand-core.mjs";
import type { BrandAssetKind, BrandParts } from "../../server/brand-core.mjs";

export type { BrandAssetKind, BrandParts };
export { brandAssetCandidates, brandPartsFromDomain };

/** Brand shown in the UI is derived from the current hostname. */
export function getBrandParts(hostname = typeof window === "undefined" ? "" : window.location.hostname): BrandParts {
  return resolveBrand(hostname);
}

export function getBrandName(hostname?: string) {
  return getBrandParts(hostname).name;
}

/** Asset-path-safe slug for the current brand, e.g. "Monvravex" -> "monvravex". Used to look up per-domain favicon/logo/badge overrides. */
export function getBrandSlug(hostname?: string) {
  return slugFromName(getBrandParts(hostname).name);
}
